import { render } from "./UserWithdraw.vue?vue&type=template&id=f3ade1d4"
import script from "./UserWithdraw.vue?vue&type=script&lang=js"
export * from "./UserWithdraw.vue?vue&type=script&lang=js"

import "./UserWithdraw.vue?vue&type=style&index=0&id=f3ade1d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__